<template>
  <div class="consulta-orden-page">
    <NavbarWorld />
    <main class="page-container py-5">
      <section class="text-center">
        <div class="badge-seguridad mb-2">
          <i class="fas fa-shield-alt"></i> Portal de Clientes Seguro
        </div>
        <h1 class="titulo-principal">Consulta de Estado de Equipo</h1>
        <p class="subtitulo">Usa nuestro asistente virtual 👉 esquina inferior derecha</p>
      </section>
    </main>
    <FooterSection />
    <AsistenteOrdenModal :auto-open="true" />
  </div>
</template>

<script>
import NavbarWorld from '@/components/NavbarWorld.vue';
import FooterSection from '@/components/FooterSection.vue';
import AsistenteOrdenModal from '@/components/AsistenteOrdenModal.vue';

export default {
  name: 'ConsultaOrdenView',
  components: {
    NavbarWorld,
    FooterSection,
    AsistenteOrdenModal
  }
};
</script>

<style scoped>
.consulta-orden-page {
  min-height: 100vh;
  background-color: #f8fafc;
  color: #1e293b;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
.page-container {
  flex: 1 0 auto;
  width: 100%;
}
.hero-banner {
  padding: 1rem 0.75rem;
}
.badge-seguridad {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.85rem;
  background: #ecfdf5;
  color: #059669;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 700;
  border: 1px solid #a7f3d0;
}
.titulo-principal {
  font-size: 1.75rem;
  font-weight: 900;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.15;
}
.subtitulo {
  font-size: 0.95rem;
  color: #64748b;
  max-width: 600px;
  margin: 0.5rem auto 0;
}
@media (min-width: 576px) {
  .titulo-principal { font-size: 2rem; }
  .subtitulo { font-size: 1rem; }
}
@media (min-width: 992px) {
  .titulo-principal { font-size: 2.2rem; }
  .subtitulo { font-size: 1.05rem; }
}
</style>